export interface TokenFormValues {
    [TOKEN_AMOUNT_KEY]: string;
    [LOCK_DURATION_KEY]: number;
}

export const TOKEN_AMOUNT_KEY = "tokenAmount" as const;
export const LOCK_DURATION_KEY = "duration" as const;
